import React from 'react';
import PropTypes from 'prop-types';

import './titled_box.scss';

export default function TitledBox(props) {
  const style = {
    color: props.color,
    borderColor: props.color,
  };

  return (
    <div className="titled-box">
      <div
        className="titled-box-title-container"
        style={style}
      >
        <div className="titled-box-title">
          {props.title}
          {
            props.titleIcon &&
              <div className="titled-box-icon">
                {props.titleIcon}
              </div>
          }
        </div>
      </div>
      <div className="titled-box-content-container">
        <div className="titled-box-content">
          {props.content}
        </div>
      </div>
    </div>
  );
}

TitledBox.propTypes = {
  title: PropTypes.node.isRequired,
  titleIcon: PropTypes.node,
  content: PropTypes.node.isRequired,
  color: PropTypes.string.isRequired,
};

TitledBox.defaultProps = {
  titleIcon: null,
};



// WEBPACK FOOTER //
// ./src/components/titled_box/titled_box.jsx